export default __webpack_public_path__ + "static/media/editing-alt.916019a9.jpg";